import { ref, type Ref } from "vue"
import { make_api_call, get_headers } from "../utils"

interface UseApiReturn<T> {
  data: Ref<T | null>
  loading: Ref<boolean>
  error: Ref<string | null>
  execute: (url: string, options?: ApiOptions) => Promise<T | null>
}

interface ApiOptions {
  method?: string
  params?: Record<string, any>
  data?: Record<string, any>
  auth?: boolean
}

export function useApi<T = any>(): UseApiReturn<T> {
  const data = ref<T | null>(null) as Ref<T | null>
  const loading = ref(false)
  const error = ref<string | null>(null)

  async function execute(
    url: string,
    options: ApiOptions = {},
  ): Promise<T | null> {
    const { method = "get", params, data: payload, auth = false } = options
    loading.value = true
    error.value = null

    try {
      const headers = auth ? await get_headers(true) : undefined
      const result = await make_api_call(url, method, params, headers, payload)
      data.value = result
      return result
    } catch (err: any) {
      error.value = err?.message || "An error occurred"
      return null
    } finally {
      loading.value = false
    }
  }

  return { data, loading, error, execute }
}
